import React from 'react';
import {defineMessages} from 'react-intl';
import type {DataGridPlayerReferralColumns, PlayerReferralGridItem} from '@igp/shared/features/player-referral';
import {DataGridPlayerReferralsClient, useReferralInfoData} from '@igp/shared/features/player-referral';
import {useUserProfileDetails} from '@igp/shared/features/user-profile';
import type {RawItem} from '@igp/shared/redux/view';
import {EntityType} from '@models';

const localized = defineMessages({
    title: {
        id: 'PlayerReferralRevenueShare_title',
        defaultMessage: 'Player Referral Revenue Share',
    },
    emptyList: {
        id: 'UserReferrerInfo_emptyList',
        defaultMessage: 'Referrer is not connected',
    },
});

type PlayerReferralRevenueShareProps = {uid: string};

export function PlayerReferralRevenueShare({uid}: PlayerReferralRevenueShareProps) {
    const columns: DataGridPlayerReferralColumns[] = [
        'referrer_id',
        'revenue_share',
        'revenue_generated_total',
        'revenue_share_offering_status',
        'expiration_date',
    ];
    const {referral, rawReferral} = useReferralInfoData(
        'UserReferralKeyValueTable',
        localized.title,
        uid,
        EntityType.PlayerReferral,
        EntityType.UserProfile
    );
    const items = (referral?.referrer_id ? [referral] : []) as PlayerReferralGridItem[];
    const rawItems: RawItem[] = referral?.referrer_id ? [rawReferral] : [];

    const viewType = 'UserReferralInfo';
    const {item: user} = useUserProfileDetails({
        id: referral?.referrer_id,
        viewType,
        fields: ['uid', 'agent_info.is_agent'],
    });
    const isAgentReferrer = user?.agent_info?.is_agent;

    return (!isAgentReferrer && user) || !referral?.referrer_id ? (
        <DataGridPlayerReferralsClient
            autoHeight
            columns={columns}
            rows={items}
            rawModels={rawItems}
            hidePagination
            emptyMessage={localized.emptyList}
        />
    ) : null;
}
